var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      directives: [
        {
          name: "show",
          rawName: "v-show",
          value: _vm.promoVisible,
          expression: "promoVisible"
        }
      ],
      class:
        "header-stripe__outer-container header-stripe--" +
        (_vm.promoStyle || "default"),
      attrs: { transition: "fade" }
    },
    [
      _c(
        "div",
        {
          staticClass: "header-stripe header-stripe--gold header-stripe--blog"
        },
        [
          _c("div", { staticClass: "header-stripe__container" }, [
            _c("div", { staticClass: "header-stripe__image" }),
            _vm._v(" "),
            _c("div", { staticClass: "header-stripe__center" }, [
              _c("p", { staticClass: "header-stripe__preheader" }, [
                _c("span", { staticClass: "desktop-only" }, [
                  _vm._v(
                    "ONLY " +
                      _vm._s(_vm.countdownText) +
                      " TO SCORE $500 OFF THE #1 RATED\n            POS SYSTEM!"
                  )
                ]),
                _vm._v(" "),
                _c("span", { staticClass: "mobile-only" }, [
                  _vm._v(
                    _vm._s(_vm.countdownText) +
                      "! SCORE $500 OFF THE #1 RATED\n            POS SYSTEM."
                  )
                ])
              ]),
              _vm._v(" "),
              _c("h3", { staticClass: "header-stripe__header" }, [
                _c(
                  "a",
                  {
                    staticClass: "header-stripe__header-phone",
                    attrs: { href: "tel:+1-800-820-9814" }
                  },
                  [_vm._v("Call 1-800-820-9814")]
                ),
                _vm._v(" "),
                _c("span", { staticClass: "header-stripe__header-desktop" }, [
                  _vm._v("or Click Below to Claim this Offer")
                ]),
                _vm._v(" "),
                _c(
                  "span",
                  {
                    staticClass: "header-stripe__header-mobile",
                    on: {
                      click: function($event) {
                        return _vm.buttonClick()
                      }
                    }
                  },
                  [_vm._v("or Learn More Here")]
                ),
                _vm._v(" "),
                _c("sup", [_vm._v("**")]),
                _vm._v(" "),
                _c("svg", { staticClass: "mobileOnlyPromoArrow" }, [
                  _c("use", { attrs: { "xlink:href": "#arrow-right-rounded" } })
                ])
              ]),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "button btn btn-mustard",
                  on: {
                    click: function($event) {
                      return _vm.buttonClick()
                    }
                  }
                },
                [_vm._v("\n          LEARN MORE\n        ")]
              )
            ])
          ])
        ]
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }